import { PayMilestoneCellRenderer } from "../components/PayMilestoneCellRenderer";

/**
 * Creates accounting column definitions with permission-based conditional columns
 */
const createAccountingColDefs = (canMakePayment: boolean) => [
  // Hidden ID fields for data integrity
  {
    headerName: "_id",
    field: "_id",
    type: "text",
    hide: true,
    sortable: false,
  },

  // Brand column
  {
    headerName: "Brand",
    field: "brand_id.name",
    type: "text",
    sortable: false,
    filterValueGetter: (params) => {
      if (!params.data?.brand_id?.name) {
        return "";
      }
      return `${params.data?.brand_id?.name} ${params.data?.brand_id?._id}`;
    },
    valueFormatter: (params) => {
      return params.data?.brand_id?.name || "";
    },
  },

  // Campaign columns
  {
    headerName: "Campaign",
    field: "campaign_id.name",
    type: "text",
    sortable: false,
    filterValueGetter: (params) => {
      if (!params.data?.campaign_id?.name) {
        return "";
      }
      return `${params.data?.campaign_id?.name} ${params.data?.campaign_id?._id}`;
    },
    valueFormatter: (params) => {
      return params.data?.campaign_id?.name || "";
    },
  },
  {
    headerName: "Campaign Short ID",
    field: "campaign_id.shortId",
    type: "text",
    sortable: false,
    filterValueGetter: (params) => {
      return params.data?.campaign_id?.shortId;
    },
    valueFormatter: (params) => {
      return params.data?.campaign_id?.shortId || "";
    },
  },

  // Creator information
  {
    headerName: "Creator",
    field: "user_id.name",
    type: "text",
    sortable: false,
    initialWidth: 150,
    filterValueGetter: (params) => {
      if (!params.data?.user_id?.name) {
        return "";
      }
      return `${params.data?.user_id?.name} ${params.data?.user_id?._id}`;
    },
    valueFormatter: (params) => {
      return params.data?.user_id?.name || "";
    },
  },

  // Milestone details
  {
    headerName: "Milestone Name",
    field: "name",
    type: "text",
    sortable: false,
    initialWidth: 200,
  },

  {
    headerName: "Status/Notes",
    field: "status",
    type: "text",
    sortable: false,
    initialWidth: 150,
  },
  {
    headerName: "Priority",
    field: "priority",
    type: "text",
    sortable: false,
    initialWidth: 100,
    valueFormatter: (params) => {
      return params.value?.charAt(0)?.toUpperCase() + params.value?.slice(1);
    },
  },

  // Financial information
  {
    headerName: "Rate",
    field: "rate",
    type: "currency",
    sortable: false,
    initialWidth: 120,
  },
  {
    headerName: "Hold Balance",
    field: "holdBalance",
    type: "currency",
    sortable: false,
    initialWidth: 130,
  },
  {
    headerName: "Paid Balance",
    field: "paidBalance",
    type: "currency",
    sortable: false,
    initialWidth: 130,
  },

  {
    headerName: "Actions",
    field: "__actions",
    type: "text",
    sortable: false,
    initialWidth: 150,
    minWidth: 150,
    cellRenderer: PayMilestoneCellRenderer,
    cellRendererParams: {
      canMakePayment: canMakePayment,
    },
    pinned: "right",
    cellClass: "text-end",
  },

  // Status fields
  {
    headerName: "Completed Date",
    field: "dateCompleted",
    type: "date",
    sortable: false,
    initialWidth: 130,
  },
  {
    headerName: "Payment Due Date",
    field: "nextPaymentDate",
    type: "date",
    sortable: false,
    initialWidth: 150,
  },

  // Department information
  {
    headerName: "Department",
    field: "campaign_id.department",
    type: "text",
    sortable: false,
    initialWidth: 120,
    valueGetter: (params) => {
      let text = "";
      if (params.data?.campaign_id?.department === "managed") {
        text = "Managed Services";
      }
      if (params.data?.campaign_id?.department === "talent") {
        text = "Talent";
      }
      return text;
    },
  },
];

// Export the function that creates column definitions based on permissions
export { createAccountingColDefs };

// Also export a default version for components that don't use permissions
export const accountingColDefs = createAccountingColDefs(true);
